export type VehiclesInvalidRecordReason = 'invalid-id' | 'invalid-name';

export class VehiclesInvalidRecord {
  constructor(
    public vehicleId: string,
    public reason: VehiclesInvalidRecordReason,
    public data: Record<string, unknown>
  ) {}
}
